import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { statusCodes } from '../../shared/constants/statusCodes';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private readonly http: HttpClient, private readonly spinner: NgxSpinnerService) { }
  get(url: string): Observable<any> {
    this.spinner.show();
    return this.http.get<any>(url).pipe(
      catchError(err => {
        return this.handleError(err);
      }), finalize(() => {
        this.spinner.hide();
      }));
  }
  post(url: string, data: object): Observable<any> {
    this.spinner.show();
    return this.http.post<any>(url, data).pipe(
      catchError(err => this.handleError(err)),
      finalize(() => this.spinner.hide())
    );
  }
  put(url: string, data: object): Observable<any> {
    this.spinner.show();
    return this.http.put<any>(url, data).pipe(
      catchError(err => this.handleError(err)),
      finalize(() => this.spinner.hide())
    );
  }
  delete(url: string): Observable<any> {
    this.spinner.show();
    return this.http.delete<any>(url).pipe(
      catchError(err => this.handleError(err)),
      finalize(() => this.spinner.hide())
    );
  }
  protected handleError(error: any): any {
    const { code } = error?.error || {};
    const knownErrors = [
      statusCodes.NETWOTK_UNAVIALABLE,
      statusCodes.CONFLICT,
      statusCodes.MOVED_PERMANENTLY,
      statusCodes.FOUND_IN_DIFFERENT_LOCATION,
      statusCodes.NOT_MODIFIED,
      statusCodes.BAD_REQUEST,
      statusCodes.UNAUTHORIZED,
      statusCodes.FORBIDDEN,
      statusCodes.NOT_FOUND,
      statusCodes.METHOD_NOT_ALLOWED,
      statusCodes.NOT_ACCEPTABLE,
      statusCodes.PROXY_AUTHENTICATION_REQUIRED,
      statusCodes.REQUEST_TIMEOUT,
      statusCodes.GONE,
      statusCodes.LENGTH_REQUIRED,
      statusCodes.PRECONDITION_FAILED,
      statusCodes.PAYLOAD_TOO_LARGE,
      statusCodes.URI_TOO_LONG,
      statusCodes.UNSUPPORTED_MEDIA_TYPE,
      statusCodes.RANGE_NOT_SATISFIABLE,
      statusCodes.EXPECTATION_FAILED,
      statusCodes.I_AM_A_TEAPOT,
      statusCodes.MISDIRECTED_REQUEST,
      statusCodes.UNPROCESSABLE_ENTITY,
      statusCodes.LOCKED,
      statusCodes.FAILED_DEPENDENCY,
      statusCodes.TOO_EARLY,
      statusCodes.UPGRADE_REQUIRED,
      statusCodes.PRECONDITION_REQUIRED,
      statusCodes.TOO_MANY_REQUESTS,
      statusCodes.REQUEST_HEADER_FIELDS_TOO_LARGE,
      statusCodes.UNAVAILABLE_FOR_LEGAL_REASONS,
      statusCodes.INTERNAL_SERVER_ERROR,
      statusCodes.NOT_IMPLEMENTED,
      statusCodes.BAD_GATEWAY,
      statusCodes.SERVICE_UNAVAILABLE,
      statusCodes.GATEWAY_TIMEOUT,
      statusCodes.HTTP_VERSION_NOT_SUPPORTED,
      statusCodes.VARIANT_ALSO_NEGOTIATES,
      statusCodes.INSUFFICIENT_STORAGE,
      statusCodes.LOOP_DETECTED,
      statusCodes.NOT_EXTENDED,
      statusCodes.NETWORK_AUTHENTICATION_REQUIRED,
      statusCodes.NETWOTK_UNAVIALABLE
    ];
    this.spinner.hide();
    if (knownErrors.includes(code)) {
      Swal.fire({
        text: error.message,
        icon: 'error'
      });
    } else {
      Swal.fire({
        text: 'Error in service',
        icon: 'error'
      });
    }
    return throwError(() => error);
  }
}
